import { configureStore, createSlice } from '@reduxjs/toolkit';

const ciemSlice = createSlice({
    name: 'ciem',
    initialState: { ciemId: null },
    reducers: {
        setId: (state, action) => {
            state.ciemId = action.payload;
        },
    },
});

export const { setId } = ciemSlice.actions;


export default ciemSlice.reducer;